var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPersonGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6157_39921",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#60B65E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6157_39921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77862 9.70265C8.76883 10.91 8.24613 12.2896 8.21439 13.8726H1.00855C0.897144 12.287 1.87649 10.1813 3.82158 9.1359C5.72198 8.11445 8.28175 8.34439 9.77862 9.70265Z",
    fill: "#60B65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41472 3.98406C3.38104 2.43343 4.65121 1.00845 6.41364 1.00003C8.04783 0.99226 9.40414 2.38679 9.3886 4.02422C9.37305 5.66682 8.03746 6.98298 6.38903 6.98039C4.71727 6.9778 3.4063 5.65711 3.41536 3.98471L3.41472 3.98406Z",
    fill: "#60B65E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.955,
    cy: 13.955,
    r: 4.955,
    fill: "#60B65E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.494 14.4912C14.494 15.1637 14.4949 15.798 14.494 16.4324C14.4936 16.7711 14.2906 17.0018 13.998 17C13.7055 16.9982 13.507 16.7693 13.5061 16.4283C13.5052 15.7944 13.5061 15.1605 13.5061 14.4912C13.4174 14.4912 13.3394 14.4912 13.261 14.4912C12.6938 14.4912 12.1261 14.4926 11.5589 14.4908C11.2224 14.4894 10.9926 14.2798 11.0002 13.9872C11.0074 13.7001 11.2305 13.5007 11.5553 13.4998C12.196 13.4976 12.8363 13.4994 13.5061 13.4994C13.5061 13.3497 13.5061 13.218 13.5061 13.0863C13.5061 12.564 13.5039 12.0411 13.507 11.5188C13.5088 11.211 13.7158 10.9987 14.0021 11C14.2884 11.0014 14.4922 11.2137 14.4931 11.5228C14.4958 12.1711 14.494 12.8193 14.494 13.4989C14.589 13.4989 14.6683 13.4989 14.7472 13.4989C15.3072 13.4989 15.8668 13.498 16.4269 13.4989C16.7687 13.4998 16.9955 13.6965 16.9999 13.9908C17.0044 14.2838 16.7759 14.4894 16.4372 14.4903C15.87 14.4921 15.3023 14.4908 14.7351 14.4908C14.6625 14.4908 14.5899 14.4908 14.494 14.4908V14.4912Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPersonGreen);
export default __webpack_public_path__ + "static/media/add_person_green.baca3525d883ffb09077792ba9ec3b84.svg";
export { ForwardRef as ReactComponent };